// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c7ad57c7","124":"47e72fcd","218":"f48692b1","256":"c3e59a76","321":"69e6c7b0","355":"e82b1108","516":"ff2f02b1","681":"d1df94c4","787":"c6b74f94","790":"85bd1a5e"}[chunkId] + ".chunk.js";
};